<div id="install-modal" *ngIf="isModalVisible">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Install App</h5>
          <button type="button" class="close" (click)="closeModal()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Install BuyRentSale App on your device for a better experience.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" (click)="installApp()">
            <i class="fas fa-mobile-alt" style="margin-right: 5px;"></i> PWA
          </button>
          <a href="https://buyrentsale.com/apk/brs.apk" class="btn btn-secondary">
            <i class="fab fa-google-play" style="margin-right: 5px;"></i> Android APK
          </a>
          <button type="button" class="btn btn-primary" (click)="installApp()">
            <i class="fas fa-mobile-alt" style="margin-right: 5px;"></i> Playstore
          </button>
        </div>
      </div>
    </div>
</div>